import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';

export { useDebriefApp } from './useDebriefApp';
export { useCurrentTracklog } from './useCurrentTracklog';
export { useCurrentDebrief } from './useCurrentDebrief';
export { useMapControls } from './useMapControls';
export { useChrono } from './useChrono';
export { useMapSettings } from './useMapSettings';
export { useDebriefRouter } from './useDebriefRouter';
export { useCurrentAircraft } from './useCurrentAircraft';
export { useDebriefSegments } from './useDebriefSegments';

export const useDebriefSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useDebriefDispatch = () => useDispatch<AppDispatch>();
